import { render, staticRenderFns } from "./_base-ci-type-picker.vue?vue&type=template&id=16570fcf&scoped=true&"
import script from "./_base-ci-type-picker.vue?vue&type=script&lang=js&"
export * from "./_base-ci-type-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-ci-type-picker.vue?vue&type=style&index=0&id=16570fcf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16570fcf",
  null
  
)

export default component.exports